module.exports = __webpack_public_path__ + "static/img/Michael-Wang_Marriot.611f2ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/Michael-Wang_Marriot.jpg
// module id = 10JR
// module chunks = 0